<app-loading></app-loading>
<app-header *ngIf="!isAdminRoute()"></app-header>
<router-outlet></router-outlet>
<app-footer></app-footer>

